export default __webpack_public_path__ + "static/media/keto_drinks.d64c42eb.jpg";